import * as React from 'react';

interface Props {
  items: any[];
  itemIdList: string[];
  onClick: (id: string) => void;
  getItemName: (item: any) => string;
  allItemsTitle: string;
  getItemMeta?: (item: any) => string;
  getItemColor?: (item: any, index: number) => string;
  itemCounts?: Record<string, number>;
  showItemCounts?: boolean;
}

export function ItemsBar(props: Props) {
  const {
    itemIdList,
    items,
    onClick,
    getItemName,
    allItemsTitle,
    getItemMeta,
    getItemColor,
    itemCounts = {},
    showItemCounts = true
  } = props;

  const isSeveralItems = items.length > 1;
  const isAllItemsShow = itemIdList.length === items.length;
  const mobileSelectValue = isAllItemsShow ? 'all' : itemIdList[0] || 'all';

  const isItemShow = (item: any) => {
    return itemIdList.includes(item.id);
  };

  return (
    <>
      <div className="pcal-kids pcal-kids--desktop">
        {isSeveralItems && (
          <button type="button" className={isAllItemsShow ? 'pcal-all pcal-all--on' : 'pcal-all'} onClick={() => onClick('all')}>
            {allItemsTitle}
          </button>
        )}

        {items.map((item: any, index: number) => {
          const avatarUrl = item.avatar;
          const isAvatarUrlExist = typeof avatarUrl !== 'undefined' && avatarUrl !== '';
          const firstNameInitial = item.firstName.substring(0, 1);
          const itemColor = getItemColor ? getItemColor(item, index) : '#227ebd';
          const isOn = isItemShow(item);
          const chipStyle = isOn ? { borderColor: itemColor, boxShadow: `inset 0 0 0 1px ${itemColor}` } : undefined;
          const avatarStyle = isAvatarUrlExist
            ? { backgroundImage: `url(${avatarUrl})`, opacity: isOn ? 1 : 0.5 }
            : { background: itemColor, opacity: isOn ? 1 : 0.5 };
          const countStyle = isOn ? { background: `${itemColor}1f`, color: itemColor } : undefined;

          return (
            <button
              type="button"
              className={isOn ? 'pcal-kid pcal-kid--on' : 'pcal-kid'}
              style={chipStyle}
              onClick={() => onClick(item.id)}
              key={`item_${item.id}`}
            >
              <span className="pcal-avatar" style={avatarStyle}>{isAvatarUrlExist ? null : firstNameInitial}</span>
              <span className="pcal-kid__meta">
                <span className="pcal-kid__name">{item.firstName}</span>
                <span className="pcal-kid__year">{getItemMeta ? getItemMeta(item) : item.lastName}</span>
              </span>
              {showItemCounts ? (
                <span className="pcal-kid__count" style={countStyle}>
                  {itemCounts[item.id] ?? item.itemCount ?? 0}
                </span>
              ) : null}
            </button>
          );
        })}
      </div>

      {isSeveralItems && (
        <div className="bItemsBar__mobileWrapper">
          <div className="eCalendarFilterButtons__selectWrapper">
            <select
              className="eCalendarFilterButtons__select"
              value={mobileSelectValue}
              onChange={e => onClick(e.target.value)}
            >
              <option value="all">{allItemsTitle}</option>
              {items.map((item: any) => (
                <option key={item.id} value={item.id}>
                  {getItemName(item)}
                </option>
              ))}
            </select>
            <svg className="eCalendarFilterButtons__chevron" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M5 8l5 5 5-5" stroke="#ffffff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
          </div>
        </div>
      )}
    </>
  );
}
